/**
 * @typedef {import('vue').ComponentOptions<Vue>} VueComponent
 */

/** @type {VueComponent} */
import Vue from 'vue';

export default {
    props: {
        linkBuilder: {
            type: Array,
        },
    },

    methods: {
        getButtonColor(button) {
            return `button-v2 button-v2--${button.color}`;
        },

        checkIsOpenConfiguratorButton(button) {
            const isButtonTypeExternal = button.type === 'external';
            const isSiteEurope = this.$root.handle === 'default';
            const doesButtonIncludeQueryParams =
                button.linkUrl &&
                (button.linkUrl.includes('openConfigurator=true') ||
                    button.linkUrl.includes('openTestdrive=true'));
            return (
                isButtonTypeExternal &&
                isSiteEurope &&
                doesButtonIncludeQueryParams
            );
        },
    },
};
